(function () {
  var root = document.querySelector('[data-csc-cert-application]');
  if (!root) return;
  document.documentElement.dataset.csSuppressNewsletterPopup = 'true';
  window.CannaSelectionSuppressNewsletterPopup = true;
  var form = root.querySelector('[data-csc-cert-form]');
  var step = 1;
  var submitted = false;
  var copy = JSON.parse(root.querySelector('[data-csc-cert-copy]').textContent);
  var serverErrors = {
    'Die Anfrage konnte nicht verarbeitet werden.': 'failed',
    'Bitte wählt die gewünschte Leistung aus.': 'service',
    'Bitte vervollständigt die Angaben zu eurer Anbauvereinigung.': 'club',
    'Bitte ergänzt die Angaben zu Anbausystem und Produktionsstand.': 'cultivation',
    'Bitte ordnet die Nährstoffversorgung im Coco-System ein.': 'coco',
    'Bitte gebt vollständige Kontaktdaten an.': 'contact',
    'Bitte bestätigt Dokumentenprüfung, Vor-Ort-Audit, die gesonderte Beauftragung externer Laborleistungen und Datenschutz.': 'readiness'
  };
  function analyticsAllowed() { try { return !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed || window.Shopify.customerPrivacy.analyticsProcessingAllowed(); } catch (_) { return false; } }
  function event(name, detail) { if (!analyticsAllowed()) return; window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name, landing_path: location.pathname }, detail || {})); }
  function message(text, error) { var node = root.querySelector('[data-csc-cert-message]'); node.textContent = text || ''; node.classList.toggle('is-error', !!error); }
  function checked(name) { return Array.prototype.slice.call(form.querySelectorAll('[name="' + name + '"]:checked')).map(function (node) { return node.value; }); }
  function bool(name) { return Boolean(form.elements[name]?.checked); }
  function show(target, focus) {
    step = target;
    form.querySelectorAll('[data-csc-cert-step]').forEach(function (node) { node.hidden = Number(node.dataset.cscCertStep) !== target; });
    form.querySelectorAll('[data-csc-cert-progress]').forEach(function (node) {
      var active = Number(node.dataset.cscCertProgress) === target;
      node.classList.toggle('is-active', active);
      if (active) node.setAttribute('aria-current', 'step'); else node.removeAttribute('aria-current');
    });
    form.querySelector('[data-csc-cert-back]').hidden = target === 1;
    form.querySelector('[data-csc-cert-next]').hidden = target === 7;
    form.querySelector('[data-csc-cert-submit]').hidden = target !== 7;
    message('');
    if (focus) {
      var legend = form.querySelector('[data-csc-cert-step="' + target + '"] legend');
      legend.tabIndex = -1;
      legend.focus({ preventScroll: true });
    }
  }
  function params() { var p = new URLSearchParams(location.search); return { utm_source: p.get('utm_source') || '', utm_medium: p.get('utm_medium') || '', utm_campaign: p.get('utm_campaign') || '', utm_content: p.get('utm_content') || '', referrer: document.referrer || '', landing_path: location.pathname }; }
  function toggleCoco() {
    var active = checked('systems').includes('coco');
    root.querySelector('[data-csc-cert-coco]').hidden = !active;
    form.elements.coco_nutrition_type.required = active;
    if (!active) form.elements.coco_nutrition_type.setCustomValidity('');
  }
  function validity(target) {
    var scope = form.querySelector('[data-csc-cert-step="' + target + '"]');
    var fields = scope.querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i += 1) {
      var field = fields[i];
      field.setCustomValidity('');
      if (!field.validity.valid) {
        var error = field.validity.typeMismatch && field.type === 'email' ? copy.email : field.validity.typeMismatch && field.type === 'url' ? copy.url : copy.required;
        field.setCustomValidity(error);
        field.reportValidity();
        message(error, true);
        return false;
      }
    }
    if (target === 2 && !checked('systems').length) { message(copy.missing, true); return false; }
    return true;
  }
  function successUrl(value) {
    var fallback = new URL(root.dataset.successUrl, location.origin);
    var destination = new URL(value || fallback.href, location.origin);
    if (destination.origin !== location.origin) return fallback.href;
    var path = destination.pathname.replace(/^\/(?:en|es)(?=\/)/, '');
    if (path !== '/pages/csc-zertifizierung-danke') return fallback.href;
    return fallback.pathname + destination.search + destination.hash;
  }
  function payload() {
    var laboratorySelected = checked('laboratory_status');
    var quality = {};
    ['batch_documentation', 'input_list', 'hygiene_plan', 'ipm_plan', 'quality_manager', 'cultivation_manager', 'laboratory_analyses', 'pathogen_screening'].forEach(function (key) { quality[key] = bool('quality_' + key); });
    var laboratory = {};
    ['cannabinoids', 'pesticides', 'heavy_metals', 'mycotoxins', 'microbiology', 'terpenes', 'pathogens', 'no_testing'].forEach(function (key) { laboratory[key] = laboratorySelected.includes(key); });
    return { type: 'csc_certification_request', service: { primary: form.elements.service_primary.value, modules: checked('systems'), consulting_systems: form.elements.service_primary.value === 'beratung' ? checked('systems') : [] }, club: { name: form.elements.club_name.value, legal_form: form.elements.legal_form.value, city: form.elements.city.value, state: form.elements.state.value, website: form.elements.website.value, permission_status: form.elements.permission_status.value, cultivation_active: form.elements.cultivation_active.value === 'ja', planned_start: form.elements.planned_start.value, csc_finder_url: form.elements.csc_finder_url.value, club_account_id: form.elements.club_account_id.value }, cultivation: { systems: checked('systems'), coco_nutrition_type: form.elements.coco_nutrition_type.value, production_areas: form.elements.production_areas.value, estimated_scale: form.elements.estimated_scale.value, harvests_per_year: form.elements.harvests_per_year.value, description: form.elements.description.value }, quality_status: quality, laboratory_status: laboratory, readiness: { document_review: bool('document_review'), on_site_audit: bool('on_site_audit'), external_lab_costs: bool('external_lab_costs'), anonymous_standard_development: bool('anonymous_standard_development') }, contact: { first_name: form.elements.first_name.value, last_name: form.elements.last_name.value, role: form.elements.contact_role.value, email: form.elements.email.value, phone: form.elements.phone.value, preferred_time: form.elements.preferred_time.value }, attribution: params(), consents: { privacy: bool('privacy'), marketing: bool('marketing'), public_case_study: bool('public_case_study') }, company: form.elements.company.value };
  }
  function prefill() {
    var p = new URLSearchParams(location.search);
    var service = p.get('service');
    var module = p.get('module') || p.get('system');
    var aliases = { hydroponik: 'hydro-soilless' };
    form.querySelectorAll('[name="service_primary"]').forEach(function (node) { if (node.value === service) node.checked = true; });
    if (module) {
      var selected = module.split(',').map(function (value) { return aliases[value] || value; });
      form.querySelectorAll('[name="systems"]').forEach(function (node) { if (selected.includes(node.value)) node.checked = true; });
    }
    toggleCoco();
  }
  form.querySelectorAll('[name="systems"]').forEach(function (node) { node.addEventListener('change', function () { toggleCoco(); event('csc_application_module_selected', { module: node.value, selected: node.checked }); }); });
  form.querySelectorAll('[name="service_primary"]').forEach(function (node) { node.addEventListener('change', function () { event('csc_application_service_selected', { service: node.value }); }); });
  form.querySelector('[data-csc-cert-next]').addEventListener('click', function () { if (!validity(step)) return; event('csc_application_step_complete', { step: step }); show(step + 1, true); });
  form.querySelector('[data-csc-cert-back]').addEventListener('click', function () { show(step - 1, true); });
  form.addEventListener('focusin', function () { if (!form.dataset.started) { form.dataset.started = '1'; event('csc_application_start'); } });
  form.addEventListener('submit', async function (submitEvent) {
    submitEvent.preventDefault();
    var button = form.querySelector('[data-csc-cert-submit]');
    if (button.disabled || submitted) return;
    for (var target = 1; target <= 7; target += 1) {
      if (!validity(target)) {
        if (target !== step) { show(target, true); validity(target); }
        return;
      }
    }
    button.disabled = true;
    button.textContent = copy.sending;
    message('');
    try {
      var response = await fetch(root.dataset.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload()) });
      var result = await response.json().catch(function () { return {}; });
      if (!response.ok || !result.ok) {
        message(copy[serverErrors[result.error]] || copy.failed, true);
        event('csc_application_submit_error');
        return;
      }
      var destination = successUrl(result.redirect_url);
      submitted = true;
      event('csc_application_submit_success');
      location.assign(destination);
    } catch (_) {
      message(copy.failed, true);
      event('csc_application_submit_error');
    } finally {
      if (!submitted) { button.disabled = false; button.textContent = copy.submit; }
    }
  });
  function clearValidity() { form.querySelectorAll('input, select, textarea').forEach(function (field) { field.setCustomValidity(''); }); message(''); }
  form.addEventListener('input', clearValidity);
  form.addEventListener('change', clearValidity);
  window.addEventListener('pagehide', function () { if (form.dataset.started && !submitted) event('csc_application_abandon', { step: step }); });
  prefill(); show(1);
})();
